module.exports = __webpack_public_path__ + "img/all_for_one.banner.5139d76f.jpg";